const BenefitInfo = [
  {
    id: "1",
    title: "Standardization",
    paragraph: "When working in a global workplace, it’s often difficult to gauge learners’ training experiences.",
    collapse: "When working in a global workplace, it’s often difficult to gauge learners’ training experiences."
  },

  {
    id: "2",
    title: "Reduced Costs",
    paragraph: "With eLearning, there’s no cost to reproduce materials and, thanks to mobile learning and microlearning.",
    collapse: "When working in a global workplace, it’s often difficult to gauge learners’ training experiences."
  },

  {
    id: "3",
    title: "More Customization",
    paragraph: "Just like learners aren’t one-size-fits-all, learning is not a one-size-fits-all experience.",
    collapse: "When working in a global workplace, it’s often difficult to gauge learners’ training experiences."
  },

  {
    id: "4",
    title: "Affordable Pricing",
    paragraph: "With eLearning, there’s no cost to reproduce materials and, thanks to mobile learning and microlearning.",
    collapse: "When working in a global workplace, it’s often difficult to gauge learners’ training experiences."
  },

  {
    id: "5",
    title: "Learner Satisfaction",
    paragraph: "If you really want students to retain what they learn, you’ll need to aim for high satisfaction rates.",
    collapse: "When working in a global workplace, it’s often difficult to gauge learners’ training experiences."
  },

  {
    id: "6",
    title: "Multimedia Materials",
    paragraph: "One of the main reasons why custom eLearning is effective is that it’s the perfect delivery method.",
    collapse: "When working in a global workplace, it’s often difficult to gauge learners’ training experiences."
  },

  


]

export default BenefitInfo;